import "../../styles/parishsoft-session-expired.scss";

export default function ParishSoftSessionExpired() {
  return (
    <main className="parishsoft-session-expired" role="alert">
      <section className="parishsoft-session-expired-content">
        <h1>Your session has expired</h1>
        <p>Close and reopen Communications from ParishSOFT to continue.</p>
      </section>
    </main>
  );
}
